"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var CutOutSmall = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18" }, props),
        React.createElement("path", { d: "M8.42919458,9.0043335 L5.08512495,3.77377034 C4.75424251,3.24997773 5.51484737,2.66954041 5.93974887,3.24997773 L9.00654485,8.0043335 L12.0480119,3.25273563 C12.373612,2.67628479 13.2447515,3.19281006 12.9338132,3.73041076 L9.58389511,9.0043335 L10.7677568,11.1292033 C10.9374333,10.834745 11.1845181,10.5796293 11.5,10.3974858 C12.4565852,9.84520103 13.6797661,10.1729513 14.2320508,11.1295366 L14.7320508,11.995562 C15.2843356,12.9521472 14.9565852,14.175328 14,14.7276128 C13.0434148,15.2798975 11.8202339,14.9521472 11.2679492,13.995562 L9.00654485,10.0043335 L6.73205081,13.995562 C6.17976606,14.9521472 4.95658525,15.2798975 4,14.7276128 C3.04341475,14.175328 2.71566444,12.9521472 3.26794919,11.995562 L3.76794919,11.1295366 C4.32023394,10.1729513 5.54341475,9.84520103 6.5,10.3974858 C6.81548192,10.5796293 7.06256665,10.834745 7.23224321,11.1292033 L8.42919458,9.0043335 Z M5.8660254,13.495562 L6.3660254,12.6295366 C6.64216778,12.151244 6.47829262,11.5396536 6,11.2635112 C5.52170738,10.9873688 4.91011697,11.151244 4.6339746,11.6295366 L4.1339746,12.495562 C3.85783222,12.9738546 4.02170738,13.585445 4.5,13.8615874 C4.97829262,14.1377298 5.58988303,13.9738546 5.8660254,13.495562 Z M12.1339746,13.495562 C12.410117,13.9738546 13.0217074,14.1377298 13.5,13.8615874 C13.9782926,13.585445 14.1421678,12.9738546 13.8660254,12.495562 L13.3660254,11.6295366 C13.089883,11.151244 12.4782926,10.9873688 12,11.2635112 C11.5217074,11.5396536 11.3578322,12.151244 11.6339746,12.6295366 L12.1339746,13.495562 Z" })));
};
CutOutSmall.displayName = 'CutOutSmall';
exports.default = CutOutSmall;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=CutOutSmall.js.map